export default {
    setSortType: (state, data) => {
      state.sort = {
        ...state.sort,
        [data.slotName ?? 'default']: Array.isArray(data.sort) ? data.sort.map(s => {return {...s} })  : {...data.sort}
      }        
    },
}